import { Skeleton } from "@/shared/ui/skeleton";

import { useRankLookup } from "../../api/useRankLookup";
import { useStatsSummary } from "../../api/useStatsSummary";

// Ранг игрока после последнего рейтингового матча — подпись под ником в меню. Сводка
// грузится — заглушка; ранга нет (только обычные матчи) или сводка ещё считается — ничего.
export const PlayerRank = ({ className }: { className?: string }) => {
  const rankLookup = useRankLookup();
  const { data, isPending } = useStatsSummary();
  const badge = data?.summary?.rank_badge ?? null;
  if (isPending) {
    return <Skeleton className="mt-1 h-3 w-16" />;
  }
  if (badge === null) {
    return null;
  }
  return <span className={className}>{rankLookup(badge).name}</span>;
};
